import backlinkApi from './backlinkNewApi';

export const backlinkReferringIpApi = backlinkApi.injectEndpoints({
  endpoints: build => ({
    getReferringIpsCount: build.query({
      query: body => ({
        url: '/api_backlink/v1/referring_ips/',
        method: 'POST',
        body: body
      })
    }),
    getReferringIps: build.mutation({
      query: body => ({
        url: '/api_backlink/v1/referring_ips/',
        method: 'POST',
        body: body
      })
    })
  })
});

export const {
  useGetReferringIpsCountQuery,
  useGetReferringIpsMutation
} = backlinkReferringIpApi;
export default backlinkReferringIpApi;
